export class FilterModel{
    event:string;
    username:string;
    time:string;
    time_end:string;
    date_start:string;
    date_final:string;
    km:string;

    constructor(event?:string){

    }
}


// WEBPACK FOOTER //
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/models/filterModel.ts